import currency from 'currency.js';

import { DELIVERABLE_ADDITIONAL_COSTS_DESCRIPTION } from 'utils/deliverables';

type CostAttributionState = {
  [x: string]: string
};

export function calculateTotalCCACosts(costAttribution: CostAttributionState) {
  return (sum: currency, key: string) => {
    if (key === DELIVERABLE_ADDITIONAL_COSTS_DESCRIPTION) {
      return sum;
    }

    return sum.add(currency(costAttribution[key] || 0));
  };
}
